import { UtenteVO } from "./utenteVO";

export class VisibilitaAttoVO {
    dataInizioVisibilita: string;
    dataFineVisibilita: string;
    operatore: UtenteVO;
    utente: UtenteVO;
}